import { render, staticRenderFns } from "./Opening.vue?vue&type=template&id=6b501142&scoped=true"
import script from "./Opening.vue?vue&type=script&lang=js"
export * from "./Opening.vue?vue&type=script&lang=js"
import style0 from "./Opening.vue?vue&type=style&index=0&id=6b501142&prod&lang=scss&scoped=true"
import style1 from "./Opening.vue?vue&type=style&index=1&id=6b501142&prod&lang=scss&scoped=true"
import style2 from "./Opening.vue?vue&type=style&index=2&id=6b501142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b501142",
  null
  
)

export default component.exports